import React from 'react';
export function FeelingsSection() {
  return <section className="w-full py-16 px-6 md:px-8" style={{
    background: 'linear-gradient(to bottom, #E8E0F0, #C4B5E0)',
    paddingTop: '60px',
    paddingBottom: '60px'
  }} data-id="element-26">
      <div className="max-w-2xl mx-auto text-center" data-id="element-27">
        <h3 className="text-2xl md:text-3xl font-bold text-[#3D3250] mb-8" data-id="element-28">
          Lo que vas a sentir realmente...{' '}
          <span className="italic text-[#6D5E85]" data-id="element-29">No es "motivación"</span>, es:
        </h3>

        <div className="space-y-4 text-left max-w-md mx-auto" data-id="element-30">
          {['"Ok… sé por dónde empezar."', '"Hoy hice lo mínimo y no me destruí."', '"No estoy loca: estoy cansada."', '"Tengo un sistema."'].map((item, idx) => <div key={idx} className="flex items-center gap-4 bg-white/60 backdrop-blur-sm rounded-2xl px-5 py-4 border border-white/40 shadow-sm pt-[7px] pb-[7px]" data-id="element-31">
              <span className="text-xl flex-shrink-0 text-[#6D5E85]" data-id="element-32">✔️</span>
              <p className="text-[#3D3250] font-medium text-[22px]" data-id="element-33">{item}</p>
            </div>)}
        </div>
      </div>
    </section>;
}